"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_BRAND: function() {
        return ADD_BRAND;
    },
    ASSIGN_TO_BRAND: function() {
        return ASSIGN_TO_BRAND;
    },
    DELETE_BRAND: function() {
        return DELETE_BRAND;
    },
    DUPLICATE_BRAND: function() {
        return DUPLICATE_BRAND;
    },
    GENERATE_BRANDS: function() {
        return GENERATE_BRANDS;
    },
    RESET_BRANDS: function() {
        return RESET_BRANDS;
    },
    UPDATE_BRAND: function() {
        return UPDATE_BRAND;
    }
});
const ADD_BRAND = "ADD_BRAND";
const UPDATE_BRAND = "UPDATE_BRAND";
const DELETE_BRAND = "DELETE_BRAND";
const RESET_BRANDS = "RESET_BRANDS";
const GENERATE_BRANDS = "GENERATE_BRANDS";
const DUPLICATE_BRAND = "DUPLICATE_BRAND";
const ASSIGN_TO_BRAND = "ASSIGN_TO_BRAND";
